var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    {
      class: [
        "royale-page",
        {
          "danger-phase":
            _vm.activeRoom &&
            _vm.activeRoom.state === "Choosing" &&
            _vm.secondsLeft <= 5,
        },
      ],
    },
    [
      _c("header", { staticClass: "royale-header" }, [
        _c(
          "button",
          {
            staticClass: "quiet-button",
            attrs: { type: "button" },
            on: { click: _vm.backToLobby },
          },
          [_vm._v("撤离战区")]
        ),
        _c("div", { staticClass: "title-wrap" }, [
          _c("span", { staticClass: "eyebrow" }, [_vm._v("BATTLE ZONE")]),
          _c("h1", [
            _vm._v("战区 #" + _vm._s(_vm.activeRoom && _vm.activeRoom.roomId)),
          ]),
          _c("p", [
            _vm._v(_vm._s(_vm.stateText) + " · 争夺奖池 "),
            _c("strong", [
              _vm._v(
                _vm._s(
                  _vm.activeRoom &&
                    _vm.formatCoin(
                      _vm.activeRoom.potAmount ||
                        _vm.activeRoom.players.length * 10
                    )
                ) + " Coin1"
              ),
            ]),
          ]),
        ]),
        _vm.activeRoom
          ? _c("div", { staticClass: "survivor-count" }, [
              _c("span", [_vm._v("幸存者")]),
              _c("strong", [_vm._v(_vm._s(_vm.alivePlayers.length))]),
              _c("small", [
                _vm._v("/ " + _vm._s(_vm.activeRoom.players.length)),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm.activeRoom
        ? _c("section", { staticClass: "game-band" }, [
            _c("div", { staticClass: "combat-hud" }, [
              _c("div", [
                _c("span", [_vm._v("当前轮次")]),
                _c("strong", [
                  _vm._v(_vm._s(_vm.activeRoom.currentRound || 0)),
                  _c("small", [
                    _vm._v("/" + _vm._s(_vm.activeRoom.totalRounds || "-")),
                  ]),
                ]),
              ]),
              _c("div", [
                _c("span", [_vm._v("参战规模")]),
                _c("strong", [
                  _vm._v(_vm._s(_vm.activeRoom.players.length)),
                  _c("small", [
                    _vm._v("/" + _vm._s(_vm.activeRoom.maxPlayerCount || 6)),
                  ]),
                ]),
              ]),
              _c("div", [
                _c("span", [_vm._v("战区指挥官")]),
                _c("strong", [_vm._v(_vm._s(_vm.hostName))]),
              ]),
              _c("div", [
                _c("span", [_vm._v("战局状态")]),
                _c(
                  "strong",
                  {
                    class:
                      "hud-state state-" + _vm.activeRoom.state.toLowerCase(),
                  },
                  [_vm._v(_vm._s(_vm.stateText))]
                ),
              ]),
            ]),
            _c("section", { staticClass: "roster-section" }, [
              _c("header", [
                _vm._m(0),
                _c("span", [
                  _vm._v(_vm._s(_vm.alivePlayers.length) + " 名仍在战场"),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "seat-grid" },
                _vm._l(_vm.seats, function (seat) {
                  return _c(
                    "article",
                    {
                      key: seat.no,
                      class: [
                        "seat",
                        {
                          occupied: seat.player,
                          dead: seat.player && !seat.player.isAlive,
                          winner: seat.player && seat.player.isWinner,
                        },
                      ],
                    },
                    [
                      seat.player
                        ? [
                            _c("div", { staticClass: "avatar-wrap" }, [
                              _c("img", {
                                attrs: { src: seat.player.avatar, alt: "" },
                              }),
                              _c("i", [_vm._v(_vm._s(seat.no))]),
                            ]),
                            _c("div", { staticClass: "player-info" }, [
                              _c("strong", [
                                _vm._v(_vm._s(seat.player.displayName)),
                              ]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    seat.player.isAi
                                      ? "AI 作战单位"
                                      : "真人参战者"
                                  )
                                ),
                              ]),
                            ]),
                            _c("b", [
                              _vm._v(_vm._s(_vm.playerStatus(seat.player))),
                            ]),
                          ]
                        : [
                            _c("div", { staticClass: "empty-seat" }, [
                              _c("i", [_vm._v(_vm._s(seat.no))]),
                              _c("div", [
                                _c("strong", [
                                  _vm._v(_vm._s(seat.no) + " 号战位"),
                                ]),
                                _c("span", [_vm._v("等待占领")]),
                              ]),
                            ]),
                            _vm.activeRoom.state === "Waiting" &&
                            (_vm.isHost || !_vm.currentPlayer)
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "secondary-button",
                                    attrs: {
                                      type: "button",
                                      disabled: _vm.busy,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.joinSeat(seat.no)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.isHost ? "部署 AI" : "占领战位"
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                    ],
                    2
                  )
                }),
                0
              ),
            ]),
            _vm.activeRoom.state === "Waiting"
              ? _c("div", { staticClass: "waiting-stage" }, [
                  _c("div", [
                    _c("span", { staticClass: "section-kicker" }, [
                      _vm._v("ASSEMBLY PHASE"),
                    ]),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.activeRoom.players.length < 2
                            ? "等待更多参战者"
                            : "战局已经可以启动"
                        )
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.isHost
                            ? "填充空余战位或直接启动爆破程序。"
                            : "等待指挥官启动战局。"
                        )
                      ),
                    ]),
                  ]),
                  _vm.isHost
                    ? _c(
                        "button",
                        {
                          staticClass: "primary-button",
                          attrs: {
                            type: "button",
                            disabled:
                              _vm.busy || _vm.activeRoom.players.length < 2,
                          },
                          on: { click: _vm.startRoom },
                        },
                        [_vm._v("启动战局")]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.showChambers
              ? _c("section", { staticClass: "chamber-stage" }, [
                  _c("header", { staticClass: "chamber-heading" }, [
                    _c("div", [
                      _c("span", { staticClass: "section-kicker" }, [
                        _vm._v("SURVIVAL DECISION"),
                      ]),
                      _c("h2", [
                        _vm._v(
                          _vm._s(
                            _vm.activeRoom.state === "Choosing"
                              ? "选择你的生存舱"
                              : "生存舱已锁定"
                          )
                        ),
                      ]),
                      _c("p", [_vm._v(_vm._s(_vm.chamberInstruction))]),
                    ]),
                    _vm.activeRoom.state === "Choosing"
                      ? _c("div", { staticClass: "countdown-wrap" }, [
                          _c("span", [_vm._v("爆破倒计时")]),
                          _c(
                            "div",
                            {
                              staticClass: "countdown",
                              class: { urgent: _vm.secondsLeft <= 5 },
                            },
                            [_vm._v(_vm._s(_vm.secondsLeft))]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    { staticClass: "chambers" },
                    _vm._l(_vm.currentPool, function (number) {
                      return _c(
                        "button",
                        {
                          key: number,
                          class: [
                            "chamber",
                            {
                              selected: _vm.selectedNumber === number,
                              occupied: _vm.chamberPlayers(number).length,
                              locked: !_vm.canChoose,
                              exploded:
                                _vm.latestExplodedRoom === number &&
                                _vm.activeRoom.state !== "Choosing",
                            },
                          ],
                          attrs: {
                            type: "button",
                            disabled: !_vm.canChoose || _vm.busy,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.choose(number)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "chamber-warning" }, [
                            _vm._v(
                              _vm._s(
                                _vm.latestExplodedRoom === number &&
                                  _vm.activeRoom.state !== "Choosing"
                                  ? "DESTROYED"
                                  : _vm.selectedNumber === number
                                  ? "LOCKED"
                                  : "SURVIVAL ROOM"
                              )
                            ),
                          ]),
                          _c("strong", { staticClass: "chamber-number" }, [
                            _vm._v(_vm._s(_vm.chamberCode(number))),
                          ]),
                          _c("span", { staticClass: "chamber-name" }, [
                            _vm._v(
                              _vm._s(
                                _vm.latestExplodedRoom === number &&
                                  _vm.activeRoom.state !== "Choosing"
                                  ? "已被摧毁"
                                  : number + " 号生存舱"
                              )
                            ),
                          ]),
                          _vm.chamberPlayers(number).length
                            ? _c(
                                "div",
                                { staticClass: "chamber-occupants" },
                                [
                                  _vm._l(
                                    _vm.chamberPlayers(number),
                                    function (player) {
                                      return _c(
                                        "span",
                                        {
                                          key: player.playerId,
                                          attrs: { title: player.displayName },
                                        },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: player.avatar,
                                              alt: "",
                                            },
                                          }),
                                          player.isAi
                                            ? _c("i", [_vm._v("AI")])
                                            : _vm._e(),
                                        ]
                                      )
                                    }
                                  ),
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.chamberPlayers(number).length
                                      ) + " 人已进入"
                                    ),
                                  ]),
                                ],
                                2
                              )
                            : _c("div", { staticClass: "chamber-empty" }, [
                                _vm._v("等待参战者进入"),
                              ]),
                          _vm.activeRoom.state === "Choosing"
                            ? _c("em", [
                                _vm._v(
                                  _vm._s(
                                    _vm.selectedNumber === number
                                      ? "你已进入此舱"
                                      : _vm.canChoose
                                      ? "点击进入"
                                      : "舱门锁定"
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]
                      )
                    }),
                    0
                  ),
                  _c(
                    "div",
                    { staticClass: "choice-status" },
                    [
                      _vm.activeRoom.state === "Choosing"
                        ? [
                            _vm.selectedNumber != null
                              ? _c("strong", [
                                  _vm._v(
                                    "生存舱已锁定：" +
                                      _vm._s(_vm.selectedNumber) +
                                      " 号"
                                  ),
                                ])
                              : _vm.currentPlayer && _vm.currentPlayer.isAlive
                              ? _c("strong", [
                                  _vm._v("你必须在倒计时结束前进入一个生存舱"),
                                ])
                              : _c("strong", [
                                  _vm._v(
                                    "你已退出战场，正在查看其他幸存者的选择"
                                  ),
                                ]),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.chosenAliveCount) +
                                  "/" +
                                  _vm._s(_vm.alivePlayers.length) +
                                  " 名幸存者已完成选择"
                              ),
                            ]),
                          ]
                        : [
                            _c("strong", [_vm._v("爆破程序正在执行")]),
                            _c("span", [
                              _vm._v("所有舱门已经封锁，等待爆炸结果。"),
                            ]),
                          ],
                    ],
                    2
                  ),
                ])
              : _vm._e(),
            _vm.activeRoom.state === "Finished"
              ? _c("section", { staticClass: "result" }, [
                  _c("span", { staticClass: "section-kicker" }, [
                    _vm._v("BATTLE COMPLETE"),
                  ]),
                  _vm.winners.length
                    ? _c("strong", [
                        _vm._v(
                          "最后幸存者：" +
                            _vm._s(
                              _vm.winners
                                .map(function (x) {
                                  return x.displayName
                                })
                                .join("、")
                            )
                        ),
                      ])
                    : _c("strong", [_vm._v("全员出局 · 本局无人生还")]),
                  _vm.currentPlayer && _vm.currentPlayer.isWinner
                    ? _c("p", [
                        _vm._v(
                          "你活到了最后，获得 " +
                            _vm._s(
                              _vm.formatCoin(_vm.currentPlayer.payoutAmount)
                            ) +
                            " Coin1"
                        ),
                      ])
                    : _vm.winners.length
                    ? _c("p", [_vm._v("奖池已经由幸存者瓜分。")])
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm.activeRoom.state === "Cancelled"
              ? _c("section", { staticClass: "result cancelled" }, [
                  _c("span", { staticClass: "section-kicker" }, [
                    _vm._v("MISSION ABORTED"),
                  ]),
                  _c("strong", [_vm._v("战局已中止")]),
                  _c("p", [_vm._v("入场筹码已经退回。")]),
                ])
              : _vm._e(),
            _vm.activeRoom.rounds.length
              ? _c("section", { staticClass: "round-history" }, [
                  _vm._m(1),
                  _c(
                    "ol",
                    _vm._l(_vm.activeRoom.rounds, function (round) {
                      return _c(
                        "li",
                        {
                          key: round.roundNo,
                          class: { pending: round.targetNumber == null },
                        },
                        [
                          _c("span", [
                            _vm._v("第 " + _vm._s(round.roundNo) + " 轮"),
                          ]),
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                round.targetNumber == null
                                  ? "生存舱开放中"
                                  : round.targetNumber + " 号生存舱爆炸"
                              )
                            ),
                          ]),
                          _c("em", [
                            _vm._v(
                              _vm._s(
                                round.targetNumber == null
                                  ? round.aliveBefore + " 名参战者"
                                  : round.aliveAfter + " 名幸存者"
                              )
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.errorMessage
        ? _c("p", { staticClass: "error-message" }, [
            _vm._v(_vm._s(_vm.errorMessage)),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "section-kicker" }, [_vm._v("COMBATANTS")]),
      _c("h2", [_vm._v("参战者状态")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _c("div", [
        _c("span", { staticClass: "section-kicker" }, [_vm._v("BLAST LOG")]),
        _c("h2", [_vm._v("爆破记录")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }